import "./styles/ranking.scss";
import "react-datepicker/dist/react-datepicker.css";

import * as React from "react";

import { Link, Redirect, useLocation, useParams } from "react-router-dom";
import { useRanking, useUser } from "../../helpers/satiBack";

import { Button } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";

import RankingTable from "./components/RankingTable";
import RankingSummary from "./components/RankingSummary";
import Announcement from "./components/Announcement";

function Ranking() {
  const { filter } = useParams();
  const { pathname } = useLocation();

  const [date, setDate] = React.useState(moment().subtract(1, "day").toDate());

  const [mode, setMode] = React.useState("monthly");

  const isToday = moment(date).isSame(moment(), "day");

  const month = (() => {
    const x = moment(date).format("MMMM YYYY");
    return `${x.charAt(0).toUpperCase()}${x.slice(1)}`;
  })();

  const onSelectDate = (date) => setDate(date);

  const { data: ranking, isLoading } = useRanking(filter, date);

  const { data: user } = useUser();

  if (!["calories", "steps", "distance", "exerciseTime"].includes(filter))
    return <Redirect to="/dashboard" />;

  return (
    <div className="ranking">
      <div
        className="container"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <div style={{ color: "#1D1F3F" }}>
          <h1 style={{ fontSize: "48px" }}>Ranking {month}</h1>
          <span>Visualiza tu lugar en el ranking de la empresa este mes:</span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignSelf: "flex-end",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <span>Categoría:</span>

            <Link to="/ranking/steps">
              <Button
                color="primary"
                outline={!pathname.includes("steps")}
                disabled={isLoading}
              >
                Pasos
              </Button>
            </Link>

            <Link to="/ranking/distance">
              <Button
                color="primary"
                outline={!pathname.includes("distance")}
                disabled={isLoading}
              >
                Distancia
              </Button>
            </Link>

            <Link to="/ranking/exerciseTime">
              <Button
                color="primary"
                outline={!pathname.includes("exerciseTime")}
                disabled={isLoading}
              >
                Tiempo
              </Button>
            </Link>

            <Link to="/ranking/calories">
              <Button
                color="primary"
                outline={!pathname.includes("calories")}
                disabled={isLoading}
              >
                Calorías
              </Button>
            </Link>
          </div>

          <div
            style={{
              display: "flex",
              alignSelf: "flex-end",
              alignItems: "center",
              gap: "0.5rem",
              marginTop: "1rem",
            }}
          >
            <span>Fecha:</span>

            <Button
              color="primary"
              outline={!isToday}
              disabled={isLoading}
              onClick={() => setDate(moment().toDate())}
            >
              Hoy
            </Button>

            <Button
              color="primary"
              outline={mode !== "monthly"}
              disabled={isLoading}
              onClick={() => setMode("monthly")}
            >
              Mes
            </Button>

            <Button
              color="primary"
              outline={mode !== "daily"}
              disabled={isLoading}
              onClick={() => setMode("daily")}
            >
              Día
            </Button>

            <DatePicker
              selected={date}
              onChange={onSelectDate}
              shouldCloseOnSelect={false}
              className="btn btn-outline-dark"
              todayButton="Hoy"
              disabled={isLoading}
            />
          </div>
        </div>
      </div>

      <div
        className="summary-container"
        style={{
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <RankingSummary
          user={user}
          data={
            ranking?.data.summary || {
              previousMonth: null,
              currentMonth: null,
              record: null,
            }
          }
          filter={filter}
          month={month}
          isLoading={isLoading}
          description={
            isToday
              ? "Este es tu lugar en el ranking al día del hoy:"
              : "Este fue tu lugar en el ranking de ese día"
          }
        />

        {mode === "daily" ? (
          <RankingTable
            filter={filter}
            data={ranking?.data.results || []}
            user={user}
            isLoading={isLoading}
            label={`Top del ${moment(date).format("D MMMM YYYY")}`}
          />
        ) : (
          <RankingTable
            filter={filter}
            data={ranking?.data.summary.monthRanking || []}
            user={user}
            isLoading={isLoading}
            label="Top del mes"
          />
        )}
      </div>

      <div
        className="container"
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
        }}
      >
        <Announcement />
        <div style={{ width: "503px", margin: "2rem" }} />
      </div>
    </div>
  );
}

export default Ranking;
